<form [formGroup]="filterFormGroup">
    <div class="flex-grow">
        <div class="filter-elements">
            <!-- Dokumenten-ID -->
            <mat-form-field>
                <mat-label>Dokumenten ID</mat-label>
                <input matInput
                       [matAutocomplete]="dokumentenId"
                       data-qa="filter-dokumenten-id"
                       formControlName="erzeugungsanlageDokumentenId">
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

                <mat-autocomplete #dokumentenId="matAutocomplete" panelWidth="200">
                    @for (id of filteredDokumentenId$ | async; track id) {
                        <mat-option [value]="id"
                                    data-qa="filter-dokumenten-id-option">
                            <span>{{ id }}</span>
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            <!-- TR-ID -->
            <mat-form-field>
                <mat-label>TR-ID</mat-label>
                <input matInput
                       [matAutocomplete]="trId"
                       data-qa="filter-tr-id"
                       formControlName="erzeugungsanlageTechnischeResourceId">
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

                <mat-autocomplete #trId="matAutocomplete" panelWidth="200">
                    @for (id of filteredTechnischeResourceI$ | async; track id) {
                        <mat-option [value]="id"
                                    data-qa="filter-tr-id-option">
                            <span>{{ id }}</span>
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            <!-- Bezeichnung VNB intern -->
            <mat-form-field>
                <mat-label>Bezeichnung VNB intern</mat-label>
                <input matInput
                       [matAutocomplete]="srId"
                       data-qa="filter-bezeichnung-vnb-intern"
                       formControlName="erzeugungsanlageBezVnbIntern">
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

                <mat-autocomplete #srId="matAutocomplete" panelWidth="200">
                    @for (value of filteredBezVnbIntern$ | async; track value) {
                        <mat-option [value]="value"
                                    data-qa="filter-bezeichnung-vnb-intern-option">
                            <span>{{ value }}</span>
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            <!-- Netzverknüpfungspunkt -->
            <mat-form-field redispatchProvideReadonly>
                <mat-label>Netzverknüpfungspunkt</mat-label>
                <input matInput
                       name="netzzuordnungNetzverknuepfungspunkte"
                       [matAutocomplete]="netzverknuepfungspunkt"
                       data-qa="filter-netzverknuepfungspunkt"
                       formControlName="netzzuordnungNetzverknuepfungspunkte">
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

                <mat-autocomplete #netzverknuepfungspunkt="matAutocomplete"
                                  panelWidth="200">
                    @for (netzverknuepfungspunkte of filteredNetzverknuepfungspunkte$ | async; track netzverknuepfungspunkte) {
                        <mat-option [value]="netzverknuepfungspunkte"
                                    data-qa="filter-netzverknuepfungspunkt-option">
                            {{ netzverknuepfungspunkte }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            <!-- Type -->
            <mat-form-field redispatchProvideReadonly>
                <mat-label>Datenfeld</mat-label>
                <mat-select
                            formControlName="type"
                            data-qa="filter-type"
                            multiple>
                    @for (type of PlanwertTypeItems; track type.key) {
                        <mat-option
                            [value]="type.key"
                            data-qa="filter-type-option"
                            class="type">
                            {{ type.key | planwertType }}
                        </mat-option>
                    }
                </mat-select>
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
            </mat-form-field>

            <!-- Date -->
            <mat-form-field redispatchProvideReadonly data-qa="filter-data-transfer-date">
                <mat-label>Planwert-Datum</mat-label>
                <mat-date-range-input formGroupName="dataTransferDate" [rangePicker]="picker"
                                      data-qa="filter-data-transfer-date">
                    <input matStartDate formControlName="start" placeholder="Start date">
                    <input matEndDate formControlName="end" placeholder="End date">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker">
                  <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
                </mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
            </mat-form-field>

            <!-- Status -->
            <mat-form-field redispatchProvideReadonly>
                <mat-label>Status</mat-label>
                <mat-select
                            formControlName="status"
                            data-qa="filter-status"
                            multiple>
                    @for (status of PlanwertStatusItems; track status.key) {
                        <mat-option
                            [value]="status.key"
                            data-qa="filter-status-option"
                            class="planwert-status"
                            [class]="planwertStatusToClass(status.key)">
                            {{ status.key | planwertStatus }}
                        </mat-option>
                    }
                </mat-select>
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
            </mat-form-field>
        </div>
    </div>

    <div class="reset-button-container">
        <button matButton="filled" type="reset" data-qa="reset-filter-button">
            <mat-icon>autorenew</mat-icon>
            Zurücksetzen
        </button>
        <button matButton="outlined" data-qa="export-csv-button" (click)="exportPlanwerte()">
            <mat-icon>file_download</mat-icon>
            CSV exportieren
        </button>
    </div>
</form>
